<script lang="ts" setup>
import type { CSSProperties } from 'vue'
import type { Router        } from 'vue-router'

import { sdLinkProps        } from './link'
import { ElIcon             } from 'element-plus'
import { computed, getCurrentInstance } from 'vue'

defineOptions({ name: 'SdLink' })

const props = defineProps(sdLinkProps)

const instance   = getCurrentInstance()!
const $router    = instance.appContext.config.globalProperties.$router as Router
const textStyle$ = computed((): CSSProperties => {
    return {
        fontSize   : props.size,
        color      : props.type ? 'inherit' : props.color, // el-link 有设置主题则继承
        fontWeight : 'lighter',
    }
})

// 传入路径是外链
const onClick = () => {
    if (props.disabled) return 
    
    const href = props.href
    if ( !href ) return

    const is_url =   /^https?:\/\//.test(props.href)
    if (is_url) {
        window.open(href, '_target')
    } else {
        const route_record = $router.resolve(href)
        if ( !route_record ) return 
     
        $router.push({
            path   : route_record.path,
            replace: !!props.replace,
        })
    }
}

</script>

<template>
    <a
        :class="[
            'sd-link',
            `sd-link--${type}`,
            { 
                'is-disabled': disabled,
                [`is-${underline}-underline`]: !disabled,
            }
        ]"
        @click="onClick"
    >
        <ElIcon v-if="icon"><component :is="icon" /></ElIcon>
        <span v-if="$slots.default" class="sd-link__inner" :style="textStyle$">
            <slot>
                {{ text }}
            </slot>
        </span>
        <slot v-if="$slots.icon" name="icon" />
    </a>
</template>
